/**
 * 文法の語彙（docs/spec/problem-format.md §2.3）。schema の `$defs.syntax` と同じ並び。
 * 語彙を足すときは schema・§2.3 の表・この表を同じ変更で直す。
 */
import type { Syntax } from './types.js';

export interface SyntaxEntry {
  id: Syntax;
  /** 表示名。 */
  label: string;
  /** 主に立ち返る先（レッスン id の前半 `<unit>-<NN>`）。目安で、検査には使わない。 */
  revisit: string;
}

export const SYNTAXES: readonly SyntaxEntry[] = [
  { id: 'read-line', label: '`readLine()` で 1 行読む', revisit: 'stage1-basics-01' },
  { id: 'split-map', label: '空白で区切って整数の配列にする', revisit: 'stage1-basics-01' },
  { id: 'int-range', label: '`Int` の範囲とオーバーフロー', revisit: 'stage1-basics-02' },
  { id: 'arithmetic', label: '四則演算・割り算と余り', revisit: 'stage1-basics-01' },
  { id: 'if-else', label: 'if / else if', revisit: 'stage1-basics-03' },
  { id: 'logical-ops', label: '`&&` / `||`', revisit: 'stage1-basics-03' },
  { id: 'for-in', label: 'for と範囲', revisit: 'stage1-basics-04' },
  { id: 'stride', label: '`stride` で飛ばす・逆に回る', revisit: 'stage1-basics-04' },
  { id: 'while', label: 'while', revisit: 'stage1-basics-05' },
  { id: 'array', label: '配列', revisit: 'stage1-basics-06' },
  { id: 'array-2d', label: '2 次元配列・グリッド', revisit: 'loops-and-complexity-04' },
  { id: 'sort', label: '`sorted()`', revisit: 'stage1-basics-06' },
  { id: 'string', label: '文字列', revisit: 'stage1-basics-07' },
  { id: 'character', label: '`Character` と文字の配列', revisit: 'stage1-basics-07' },
  { id: 'dict', label: '辞書', revisit: 'stage1-basics-08' },
  { id: 'set', label: '集合（Set）', revisit: 'stage1-basics-08' },
  { id: 'tuple', label: 'タプル', revisit: 'loops-and-complexity-01' },
  { id: 'optional', label: 'オプショナル', revisit: 'stack-queue-dict-01' },
  { id: 'function', label: '関数', revisit: 'stage1-basics-09' },
  {
    id: 'closure',
    label: 'クロージャ（`map` / `filter` / `reduce`）',
    revisit: 'stage1-basics-09',
  },
  {
    id: 'joined-output',
    label: 'まとめて出力する（`joined(separator:)`）',
    revisit: 'stage1-basics-06',
  },
];

const BY_ID = new Map(SYNTAXES.map((s) => [s.id, s]));

/** 表示名（バッククォートはインラインコードの印。画面は InlineMarkdown などで描く）。 */
export function syntaxLabel(id: Syntax): string {
  return BY_ID.get(id)?.label ?? id;
}
